import styled, { css } from "styled-components"
import colors from "@constants/colors"
import { timings, cubicBezier } from "@constants/animation"
import { bodyBold } from "@constants/typography"

export const containerBaseProps = css`
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  display: flex;
  transition: background-color ${timings.medium} ${cubicBezier};
  width: 100%;
  padding: 13px 0;
  border: none;
  border-bottom: solid 1px ${colors.divider};
  background-color: ${colors.snow};

  &:hover {
    transition: background-color ${timings.quick} ${cubicBezier};
    background-color: ${colors.divider};
    cursor: pointer;
  }

  &:focus,
  &:active {
    outline: none;
  }
`

export const Item = styled.div`
  ${containerBaseProps}
`

export const Button = styled.button`
  ${containerBaseProps}
`

export const Anchor = styled.a`
  ${containerBaseProps}
`

export const Label = styled.span<{ color?: string }>`
  ${({ color }) => css`
    ${bodyBold}
    color: ${color || colors.obsidian};
  `}
`

export const CountWrapper = styled.div`
  position: absolute;
  right: 28px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${colors.primary};
`

export const Count = styled.div`
  ${bodyBold}
  font-size: 9px;
  line-height: 16px;
  color: ${colors.snow};
`

export const IconWrapper = styled.div<{ rotate?: number }>`
  ${({ rotate }) => css`
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    display: flex;
    transform: rotate(${rotate || 0}deg);
    transition: transform ${timings.quick} ${cubicBezier};
    width: 21px;
    height: 21px;
  `}
`

export const ExpandableContainer = styled.div<{
  expanded: boolean
  expandedHeight?: number
}>`
  ${({ expanded, expandedHeight }) => css`
    position: relative;
    flex-direction: column;
    justify-content: center;
    display: flex;
    overflow: hidden;
    transition: height ${timings.quick} ${cubicBezier};
    height: ${expanded
      ? expandedHeight
        ? `${expandedHeight}px`
        : "initial"
      : 0};

    > :first-child {
      margin-top: 8px;
    }

    > :last-child {
      margin-bottom: 8px;
    }
  `}
`

export const anchorContainerStyles = css`
  position: absolute;
  flex-wrap: wrap;
  display: flex;
  visibility: hidden;
  width: 100%;
  padding: 14px 0 4px;
`

export const anchorItemStyles = css`
  width: 44px;
  height: 44px;
`
